module.exports = __webpack_public_path__ + "img/icon_4_31.fdc0b099.png";